import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import CustomDomainListCreateButton from "../CustomDomainListCreateButton";
import DomainListsDashboard from "../DomainListsDashboard";
import SplitDomainListsDashboard from "../SplitDomainListsDashboard";
import classes from "../../PublicationListSelectionSlide.module.scss";
import { BrandgenListDomain, BrandgenPublicationList } from "../../../../../types/campaignTypes";

type PublicationListsContentProps = {
  isSplitMode: boolean;
  isLoading: boolean;
  publicDomainLists: BrandgenPublicationList[];
  customDomainLists: BrandgenPublicationList[];
  selectedDomainListsIds: string[];
  selectedDomainIds: string[];
  toggleSelectDomainLists: (listId: string) => void;
  toggleSelectDomain: (domainId: string) => void;
  updateDomainList: (
    listId: string,
    listName: string,
    domainsToUpdate: BrandgenListDomain[],
    domainsToAdd: string[],
    saveUpdatedDomainListToStore: (updatedDomainLists: BrandgenPublicationList[]) => void,
  ) => void;
  createDomainList: (
    bgAdvertiserId: string,
    adLibAdvertiserId: number,
    name: string,
    domains: string[],
    saveCreatedDomainList: (createdDomainList: BrandgenPublicationList) => void,
  ) => void;
};

const PublicationListsContent: FC<PublicationListsContentProps> = ({
  isSplitMode,
  isLoading,
  publicDomainLists,
  customDomainLists,
  selectedDomainListsIds,
  selectedDomainIds,
  toggleSelectDomainLists,
  toggleSelectDomain,
  updateDomainList,
  createDomainList,
}) => (
  <>
    {!isSplitMode && <CustomDomainListCreateButton isLoading={isLoading} createDomainList={createDomainList} />}
    {isLoading && (
      <Typography className={classes.loaderLabel}>Please, wait while we get everything in order...</Typography>
    )}
    {!isLoading && (
      <div className={classes.container}>
        {isSplitMode ? (
          <>
            <SplitDomainListsDashboard
              variant="public"
              domainLists={publicDomainLists}
              selectedDomainListsIds={selectedDomainListsIds}
              selectedDomainIds={selectedDomainIds}
              toggleSelectDomainLists={toggleSelectDomainLists}
              toggleSelectDomain={toggleSelectDomain}
            />
            <SplitDomainListsDashboard
              variant="custom"
              domainLists={customDomainLists}
              selectedDomainListsIds={selectedDomainListsIds}
              selectedDomainIds={selectedDomainIds}
              toggleSelectDomainLists={toggleSelectDomainLists}
              toggleSelectDomain={toggleSelectDomain}
            />
          </>
        ) : (
          <>
            <DomainListsDashboard
              variant="public"
              domainLists={publicDomainLists}
              selectedDomainListsIds={selectedDomainListsIds}
              toggleSelectDomainLists={toggleSelectDomainLists}
            />
            <DomainListsDashboard
              variant="custom"
              domainLists={customDomainLists}
              selectedDomainListsIds={selectedDomainListsIds}
              toggleSelectDomainLists={toggleSelectDomainLists}
              updateDomainList={updateDomainList}
            />
          </>
        )}
      </div>
    )}
  </>
);

export default PublicationListsContent;
